import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form } from "../../Components/ui/form/form";
import { Input, Option, Select } from "../../Components/ui/form";
import { useMutate } from "../../Hooks/use-mutate";
import { Card } from "../../Components/ui/card";

type CreateSupplierData = {
	name: string;
	address: string;
	city: string;
	state: string;
	zip_code: string;
	country: string;
	currency: "USD" | "MXN";
	phone: string;
	email: string;
};

type CreateSupplierResponse = {
	id: number;
	name: string;
	address: string;
	city: string;
	state: string;
	zip_code: string;
	country: string;
	currency: "USD" | "MXN";
	phone: string;
	email: string;
};

const currencyOptions: Option[] = [
	{ optionLabel: "USD", optionValue: "USD" },
	{ optionLabel: "MXN", optionValue: "MXN" },
];

export const CreateSupplierForm = ({ cancel }: { cancel: () => void }) => {
	const [name, setName] = useState("");
	const [address, setAddress] = useState("");
	const [city, setCity] = useState("");
	const [state, setState] = useState("");
	const [zipCode, setZipCode] = useState("");
	const [country, setCountry] = useState("");
	const [currency, setCurrency] = useState<"USD" | "MXN">("USD");
	const [phone, setPhone] = useState("");
	const [email, setEmail] = useState("");
	const navigate = useNavigate();

	const submitResult = useMutate<CreateSupplierData, CreateSupplierResponse>(
		"/safety/suppliers",
		"POST",
	);

	const handleSubmit = async (e: React.SubmitEvent) => {
		e.preventDefault();

		const data: CreateSupplierData = {
			name,
			address,
			city,
			state,
			zip_code: zipCode,
			country,
			currency,
			phone,
			email,
		};

		try {
			const response = await submitResult.mutate(data);
			if (response?.status === 201) {
				navigate("/suppliers/" + response.data?.id);
			}
		} catch (error) {
			console.error("Failed to create supplier", error);
		}
	};

	return (
		<div className="page-mask page-mask-animation">
			<Card title="Create Supplier" titleKey="createSupplier" className="custom__card__overflow" size="sm">
				<Form
					onSubmit={handleSubmit}
					isLoading={submitResult.isLoading}
					cancel={cancel}
				>
					<Input
						label="name"
						value={name}
						onChange={(e) => setName(e.target.value)}
					/>
					<Input
						label="address"
						value={address}
						onChange={(e) => setAddress(e.target.value)}
					/>
					<Input
						label="city"
						value={city}
						onChange={(e) => setCity(e.target.value)}
					/>
					<Input
						label="state"
						value={state}
						onChange={(e) => setState(e.target.value)}
					/>
					<Input
						label="zip"
						value={zipCode}
						onChange={(e) => setZipCode(e.target.value)}
					/>
					<Input
						label="country"
						value={country}
						onChange={(e) => setCountry(e.target.value)}
					/>
					<Select
						label="currency"
						value={currency}
						onChange={(e) => setCurrency(e.target.value as "USD" | "MXN")}
						options={currencyOptions}
					/>
					<Input
						label="phone"
						value={phone}
						onChange={(e) => setPhone(e.target.value)}
					/>
					<Input
						label="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						isRequired={false}
					/>
				</Form>
			</Card>
		</div>
	);
};
